module.exports = __webpack_public_path__ + "img/motorway_9x2.ddfb25df.svg";